import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'btn1Hover',
  $names: {
    target: '[data-js-hover=btn1]',
    inner: '.mask_in',
    icon: '.c-btn-more_icon',
    iconInner: '.c-btn-more_icon_inner',
  },
  classNames: {
    iconInner: 'c-btn-more_icon_inner',
  },
  styleInfo: {
    colorHovered: '#0d0d0d',
    colorDefault: '#f1f1f1',
    bgColorHovered: '#ceff00',
    bgColorDefault: '#0d0d0d',
    bdrColorHovered: '#ceff00',
    bdrColorDefault: '#969696',
  },
}

export default class Btn1Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
    this.setIconInner()
  }

  setIconInner() {
    this.$targets.forEach(($target, i) => {
      if ($target) {
        const $icon = $target.querySelector(this.$names.icon)
        if ($icon) {
          const $iconInner = document.createElement('span')
          $iconInner.classList.add(this.classNames.iconInner)
          $iconInner.innerHTML = $icon.innerHTML
          $icon.innerHTML = ''
          $icon.appendChild($iconInner)

          gsap.set($iconInner, {
            x: '-100%',
            force3D: false,
          })
        }
      }
    })
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      const $inner = $target.querySelector(this.$names.inner)
      if ($inner) {
        gsap.killTweensOf($inner, 'backgroundColor')
        gsap.to($inner, {
          color: this.styleInfo.colorHovered,
          backgroundColor: this.styleInfo.bgColorHovered,
          borderColor: this.styleInfo.bdrColorHovered,
          duration: 0.5,
          ease: 'quart.out',
        })
      }

      const $iconInner = $target.querySelector(this.$names.iconInner)
      if ($iconInner) {
        gsap.killTweensOf($iconInner)
        gsap.to($iconInner, {
          x: '0%',
          duration: 0.5,
          delay: 0.025,
          ease: 'cubic.out',
          force3D: false,
        })
      }

      gsap.delayedCall(0.4, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $inner = $target.querySelector(this.$names.inner)
      if ($inner) {
        gsap.killTweensOf($inner, 'backgroundColor')
        gsap.to($inner, {
          color: this.styleInfo.colorDefault,
          backgroundColor: this.styleInfo.bgColorDefault,
          borderColor: this.styleInfo.bdrColorDefault,
          duration: 0.5,
          delay: 0.05,
        })
      }

      const $iconInner = $target.querySelector(this.$names.iconInner)
      if ($iconInner) {
        gsap.killTweensOf($iconInner)
        gsap.to($iconInner, {
          x: '100%',
          duration: 0.5,
          ease: 'cubic.out',
          force3D: false,
          delay: 0.05,
          onComplete: () => {
            gsap.set($iconInner, {
              x: '-100%',
              force3D: false,
            })
            resolve()
          },
        })
      } else {
        resolve()
      }
    })
  }
}